import Joi from 'joi';

const germanCarValidationSchema = Joi.object({
  name: Joi.string().trim().max(50).required().messages({
    'string.max': 'german_car.form.name.max',
    '*': 'german_car.form.name.required',
  }),
  listPrice: Joi.number().min(1).max(9999999).required().messages({
    'number.min': 'german_car.form.listPrice.min',
    'number.max': 'german_car.form.listPrice.max',
    '*': 'german_car.form.listPrice.required',
  }),
  fuelType: Joi.string().required().messages({
    '*': 'german_car.form.fuelType.required',
  }),
  enginePower: Joi.when('fuelType', {
    is: 'electric',
    then: Joi.number().min(1).max(1000).required().messages({
      'number.min': 'german_car.form.enginePower.min',
      'number.max': 'german_car.form.enginePower.max',
      '*': 'german_car.form.enginePower.required',
    }),
  }),
  electricRange: Joi.when('fuelType', {
    is: 'hybrid',
    then: Joi.number().min(1).max(1000).required().messages({
      'number.min': 'german_car.form.electricRange.min',
      'number.max': 'german_car.form.electricRange.max',
      '*': 'german_car.form.electricRange.required',
    }),
  }),

  co2Emission: Joi.when('fuelType', {
    is: 'hybrid',
    then: Joi.number().required().min(0).max(999),
  }).messages({ '*': 'expense.emission_must_be_between_0_and_999' }),

  acquisitionDate: Joi.when('fuelType', {
    is: Joi.string().valid('hybrid', 'electric').required(),
    then: Joi.number().required().messages({
      '*': 'validation.string.empty',
    }),
  }),
});

export default germanCarValidationSchema;
